import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, PhoneIcon } from 'lucide-react';
export function OpeningHoursSection() {
  return <section className="py-32 bg-beige relative" data-id="element-135">
      <div className="max-w-7xl mx-auto px-6" data-id="element-136">
        <div className="bg-weiss p-10 md:p-16 shadow-2xl grid grid-cols-1 lg:grid-cols-2 gap-16 items-center border-t-4 border-navy" data-id="element-137">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-138">
            <h2 className="text-3xl md:text-4xl font-poppins font-bold text-schwarz mb-4 uppercase tracking-tight" data-id="element-139">
              Praxis-Öffnungszeiten
            </h2>
            <h3 className="text-xl text-navy mb-8 font-lora font-bold" data-id="element-140">
              Ihre Zahngesundheit im Alltag unterbringen!
            </h3>
            <p className="text-gray-medium font-lora leading-relaxed mb-10" data-id="element-141">
              Wer mitten im Berufsleben steht, schafft es oft nicht einen
              Zahnarztbesuch im Alltag unterzubringen! Wir bieten auch nach
              Feierabend noch Sprechzeiten an und behandeln Sie von Montag bis
              Donnerstag noch bis 20 Uhr. Auch am Freitag bieten wir Ihnen bis
              20 Uhr einen Termin an. Und falls das Alles auch nicht hilft, sind
              wir am Samstag bis 14 Uhr für Sie im Einsatz! Denn Ihre
              Zahngesundheit kann nicht warten!
            </p>

            <a href="tel:091156836360" className="inline-flex items-center space-x-4 text-lg font-poppins font-bold text-schwarz hover:text-gold transition-colors group" data-id="element-142">
              <div className="w-14 h-14 bg-schwarz text-weiss flex items-center justify-center group-hover:bg-gold transition-colors" data-id="element-143">
                <PhoneIcon className="w-6 h-6" data-id="element-144" />
              </div>
              <span data-id="element-145">0911-56 83 63 60</span>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-beige/30 p-10 border border-beige" data-id="element-146">
            <div className="flex items-center space-x-4 mb-10" data-id="element-147">
              <ClockIcon className="w-8 h-8 text-navy" data-id="element-148" />
              <h4 className="text-2xl font-poppins font-bold text-schwarz uppercase" data-id="element-149">
                Unsere Zeiten
              </h4>
            </div>

            <ul className="space-y-6 font-poppins" data-id="element-150">
              <li className="flex justify-between items-center border-b border-gray-300 pb-4" data-id="element-151">
                <span className="font-bold text-schwarz" data-id="element-152">
                  Montag – Donnerstag
                </span>
                <span className="text-gray-medium" data-id="element-153">08:00 – 20:00 Uhr</span>
              </li>
              <li className="flex justify-between items-center border-b border-gray-300 pb-4" data-id="element-154">
                <span className="font-bold text-schwarz" data-id="element-155">Freitag</span>
                <span className="text-gray-medium" data-id="element-156">08:00 – 20:00 Uhr</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-157">
                <span className="font-bold text-navy" data-id="element-158">Samstag</span>
                <span className="text-navy font-bold" data-id="element-159">08:00 – 14:00 Uhr</span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}